import moment from 'moment';


export default {
  retrieveScriptList(context) {
    return new Promise(resolve => {
      axios
        .get("peon/retrieveScriptList", {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
        .then(response => {
          context.commit("setLatestVersion", response.data.body.list);
          context.commit("filterScriptList", response.data.body.list);

          resolve();
        });
    });
  },
  async retrieveDeviceList(context){
    var groupId = "";
    return axios
      .get(
        WORKMAN_URL + 
        "device/retrieveDeviceList?pageSize=100&sort=alias&groupId=" +
        groupId,
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        }
      )
      .then(response =>{
        var deviceList = [];
        response.data.body.list.forEach(function (item) {
          if(!deviceList.some(list => list.deviceId === item.deviceId)){
            deviceList.push({
              tenantId: item.tenantId,
              deviceId: item.deviceId,
              alias: item.alias,
              status: "Disconnected",
              devType: item.devType,
            });
          }
          
        });
        context.commit("setDeviceList", deviceList);
      });
  },
  retrievePeonList(context) {
    var groupId = "";
    // return axios.get('device/retrieveDeviceList?pageSize=100&sort=alias', {
    return axios
      .get(
        WORKMAN_URL +
        "device/retrieveDeviceList?pageSize=100&sort=alias&groupId=" +
        groupId,
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        }
      )
      .then(response => {
        var deviceIds = [];
        var peonList = [];

        response.data.body.list.forEach(function (item) {
          if (item.deviceTypeId === "peon" && !peonList.some(list => item.deviceId === list.deviceId)) {
            peonList.push({
              tenantId: item.tenantId,
              deviceId: item.deviceId,
              alias: item.alias,
              status: "Disconnected",
              devType: item.devType,
              assignees: item.assignees
            });

            deviceIds.push(item.deviceId);
          }
        });

        context.commit("setDeviceIds", deviceIds);
        context.commit("setPeonStatus", peonList);
      });
  },
  //20221205 그룹 리스트 출력 로직 수정
  reloadGroupPeonList(context, groupId) {
    var url = "retrieveDeviceList?pageSize=100&sort=alias&groupId=" + groupId;

    return axios
      .get("device/" + url, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(response => {
        var deviceIds = [];
        var peonList = [];

        response.data.body.list.forEach(function (item) {
          if (item.deviceTypeId === "peon" && (item.deviceGroupId === groupId || groupId === '') && !peonList.some(list => item.deviceId === list.deviceId)) {
            peonList.push({
              tenantId: item.tenantId,
              deviceId: item.deviceId,
              alias: item.alias,
              status: "Disconnected",
              devType: item.devType,
            });
            deviceIds.push(item.deviceId);
          }
        });

        context.commit("setDeviceIds", deviceIds);
        context.commit("setPeonStatus", peonList);
      });
  },
  retrieveLatestData(context) {
    return new Promise(resolve => {
      axios
        .post(
          "peon/retrieveLatestData",
          { deviceIds: this.state.deviceIds },
          {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          }
        )
        .then(response => {
          var peonList = [];
          response.data.body.list.forEach(function (item) {
            var peon = {
              tenantId: item.tenantId,
              deviceId: item.deviceId,
              version: item.version,
              status: item.status,
              cpuUsage: item.cpuUsage,
              totalMemory: item.totalMemory,
              memoryUsage: item.memoryUsage,
              totalDisk: item.totalDisk,
              diskUsage: item.diskUsage,
              tick: item.tick,
              createdDate: item.createdDate,
            };

            // peon.alias = context.getters.getPeonAlias(item.deviceId);

            peonList.push(peon);
          });

          context.commit("updatePeonStatus", peonList);
          resolve();
        });
    });
  },
  retrieveTotalNotificationCount(context,payload = {}) {
    return new Promise(resolve => {
      axios
        .post("peon/retrieveNotificationList",payload, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
        .then(response => {
          context.commit("setTotalUnconfirmedAlarmCount", response.data.body.alive);
          
          resolve();
        });
    });
  },
  // 이건 Summary.vue에서 호출해서 개수도 적고, Dashboard.vue에서 각 Peon별 Notification 업데이트 하는 용도이기 때문에
  // 애초에 deviceId나 level을 선택하면 안됨
  // Notification.vue에서는 별도로 retrieveNotificationList를 호출함
  retrieveNotificationList(context, payload = {}) {
    console.log(payload);
    return new Promise(resolve => {
      axios
        .post("peon/retrieveNotificationList", payload, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
        .then(response => {
          context.commit("setTotalUnconfirmedAlarm", response.data.body.alive);
          context.commit("setTotalAlarm", response.data.body.alarm);
          context.commit("setTotalNormalNotification", response.data.body.normal);
          context.commit("setTotalNotification", response.data.body.total);
          context.commit("updateNotificationList", response.data.body.list);

          resolve();
        });
    });
  },

  retrieveNotification(context, payload) {
    return new Promise(resolve => {
      // this._vm.$http.post('http://211.253.28.27:8080/peon/retrieveNotificationList', {'deviceIds': [payload.deviceId]}, {
      axios
        .post(
          "peon/retrieveNotificationList",
          { deviceId: payload.deviceId },
          {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          }
        )
        .then(response => {
          context.commit("updateNotification", response.data.body.list[0]);

          resolve();
        });
    });
  },
  confirmNotification(context, payload) {
    return axios
      .post(
        "peon/confirmNotification",
        {
          deviceId: payload.deviceId,
          serial: payload.serial,
          cause: payload.cause,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        }
      )
      .then(() => {
        var index = context.state.notificationList.findIndex(item => {
          return (
            item.serial === payload.serial && item.deviceId === payload.serial
          );
        });

        if (index >= 0) {
          context.state.notificationList[index].status = "confirmed";
        }
      });

    // return new Promise((resolve, reject) => {
    //     axios.post('peon/confirmNotification', {'deviceId': payload.deviceId, 'serial': payload.serial, 'cause': payload.cause }, {
    //         headers: {
    //             'Accept': 'application/json',
    //             'Authorization': accessToken()
    //         }
    //     }).then(response => {
    //         console.log("success in confirmNotification");

    //         var index = context.state.notificationList.findIndex((item) => { return item.serial === payload.serial && item.deviceId === payload.serial });

    //         if (index >= 0) {
    //             context.state.notificationList[index].status = 'confirmed';
    //         }

    //         // resolve();
    //     }).catch(error => {
    //         console.log(error);
    //     })
    // });
  },
  // 통계는 이제 Statistics.vue 자체에서 retrieveStatistics2 API 를 호출해서..
  retrieveStatistics(context) {
    return new Promise(resolve => {
      var today = new Date();
      var yesterday = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000);
      var thisMonday = new Date(
        today.getTime() -
        (today.getDay() == 0 ? 6 : today.getDay() - 1) * 24 * 60 * 60 * 1000
      );
      var thisSunday = new Date(thisMonday.getTime() + 6 * 24 * 60 * 60 * 1000); // 자바스크립트 요일은 일요일이 0, 토요일이 6, 여기서는 월요일을 주의 시작으로 간주함
      var lastMonday = new Date(thisMonday.getTime() - 7 * 24 * 60 * 60 * 1000);
      var lastSunday = new Date(thisSunday.getTime() - 7 * 24 * 60 * 60 * 1000);
      var firstDayOfThisMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      var lastDayOfThisMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      var firstDayOfLastMonth = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      var lastDayOfLastMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );

      var days = {
        today: today,
        yesterday: yesterday,
        thisMonday: thisMonday,
        thisSunday: thisSunday,
        lastMonday: lastMonday,
        lastSunday: lastSunday,
        firstDayOfThisMonth: firstDayOfThisMonth,
        lastDayOfThisMonth: lastDayOfThisMonth,
        firstDayOfLastMonth: firstDayOfLastMonth,
        lastDayOfLastMonth: lastDayOfLastMonth,
      };
      context.commit("setStatisticsDays", days);

      // context.commit('setToday', today);
      // context.commit('setYesterday', yesterday);
      // context.commit('setThisMonday', thisMonday);
      // context.commit('setThisSunday', thisSunday);
      // context.commit('setLastMonday', lastMonday);
      // context.commit('setLastSunday', lastSunday);
      // context.commit('setFirstDayOfThisMonth', firstDayOfThisMonth);
      // context.commit('setLastDayOfThisMonth', lastDayOfThisMonth);
      // context.commit('setFirstDayOfLastMonth', firstDayOfLastMonth);
      // context.commit('setLastDayOfLastMonth', lastDayOfLastMonth);



      var fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
      var toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);



      var data = {
        type: 'peon',
        from: moment(fromDate).format('YYYY-MM-DD'),
        to: moment(toDate).format('YYYY-MM-DD')
      };
      

            
      axios.post("peon/retrieveStatistics2", data, {
        headers: {
            'Accept': 'application/json',
            'Authorization': accessToken()
        }
      }).then(response => {
        var totalRunningSeconds = 0;
        response.data.body.list.forEach((item) => {
          var runningSeconds = item.runningSeconds

          if (runningSeconds == null) {
              runningSeconds = 0;
          }

          totalRunningSeconds += runningSeconds;
        });

        context.commit("setStatistics", totalRunningSeconds);

        resolve();
      });
    });
  },
  retrieveUserList(context) {
    return axios
      .get("user/retrieveUserList?pageSize=100", {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(response => {
        var userList = [];
        response.data.body.list.forEach(function (item) {
          userList.push({
            tenantId: item.tenantId,
            userId: item.userId,
            roleCode: item.roleCode,
            userName: item.userName,
            status: item.status,
          });
        });

        context.commit("updateUserList", userList);
      });
  },
  confirmUser(context, user) {
    return axios
      .get(
        WORKMAN_URL +
        "user/confirmUser?tenantId=" +
        user.tenantId +
        "&userId=" +
        user.userId,
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        }
      )
      .then(() => {
        context.dispatch("retrieveUserList");
      });
  },
  deleteUser(context, user) {
    return axios
      .get(
        WORKMAN_URL +
        "user/deleteUser?tenantId=" +
        user.tenantId +
        "&userId=" +
        user.userId,
        {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        }
      )
      .then(() => {
        context.dispatch("retrieveUserList");
      });
  },
  registerDevice(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "device/registerDevice",
          {
            deviceId: payload.deviceId,
            alias: payload.alias,
            deviceTypeId: "peon",
            devType: payload.devType,
            assignees: payload.assignees,
            isActive: payload.isActive,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          }
        )
        .then(response => {
          if (response.data.status === "0") {
            context.dispatch("retrievePeonList");

            resolve(response);
          } else {
            reject({
              status: response.data.status,
              message: response.data.message,
              error: response,
            });
          }
        })
        .catch(error => {
          reject({
            status: error.response.status,
            message: error.toString(),
            error: error,
          });
        });
    });
  },
  deleteDevice(context, deviceId) {
    return axios
      .get("device/deleteDevice?deviceId=" + deviceId, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(() => {
        context.dispatch("retrievePeonList");
      });
  },
  retrievePropertyList(context) {
    return axios
      .get("peon/retrievePropertyList", {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(response => {
        // response.data.body.list.forEach(function(item, index, array) {
        // });
        context.commit("setPropertyList", response.data.body.list);
      });
  },
  deleteProperty(context, property) {
    return axios
      .get("peon/deleteProperty", {
        params: property,
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(() => {
        context.dispatch("retrievePropertyList");
      })
      .catch(() => { });
  },
  updateProperty(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("peon/updateProperty", payload, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
        .then(response => {
          if (response.data.status === "0") {
            context.dispatch("retrievePropertyList");
            resolve(response);
          } else {
            reject({
              status: response.data.status,
              message: response.data.message,
              error: response,
            });
          }
        })
        .catch(error => {
          reject({
            status: error.response.status,
            message: error.toString(),
            error: error,
          });
        });
    });
  },
  // registerAuthority(context, payload) {
  //     return new Promise((resolve, reject) => {
  //         axios.post('kakao/registerAuthority', {'authorityName': payload.authorityName, 'description': payload.description}, {
  //             headers: {
  //                 'Accept': 'application/json',
  //                 'Authorization': accessToken()
  //             }
  //         }).then(response => {
  //             if (response.data.status === '0') {
  //                 context.dispatch('retrieveAuthorityList');

  //                 resolve(response);
  //             } else {
  //                 reject({'status': response.data.status, 'message': response.data.message, 'error': response});
  //             }
  //         }).catch(error => {
  //             reject({'status': error.response.status, 'message': error.toString(), 'error': error});
  //         });
  //     });
  // },
  // deleteAuthority(context, authorityName) {
  //     return axios.get('device/deleteAuthority?authorityName=' + authorityName, {
  //         headers: {
  //             'Accept': 'application/json',
  //             'Authorization': accessToken()
  //         }
  //     }).then(() => {
  //         context.dispatch('retrieveAuthorityList');
  //     });
  // },
  retrieveKakaoAuthorityList(context) {
    var params = {
      offset: 0,
      limit: 10,
    };
    return axios
      .post("peon/retrieveKakaoAuthorityList", params, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(response => {
        var authorityList = [];
        response.data.body.list.forEach(function (item) {
          //if (item.deviceTypeId === 'peon') {
          authorityList.push({
            authorityId: item.authorityId,
            authorityName: item.authorityName,
          });
          //authorityNames.push(item.authorityName);
          //authorityList.push(item);
          //}
        });
        //context.commit('setAuthorityName', authorityNames);
        context.commit("setAuthorityList", authorityList);
      });
  },

  //230321 카카오 User List 출력 로직 추가
  retrieveKakaoUserList(context) {
    var params = {
      offset: 0,
      limit: 1000,
    };
    return axios
      .post("peon/retrieveKakaoUserList", params, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      })
      .then(response => {
        // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
        var retrieveKakaoUserList = [];
        response.data.body.list.forEach(item => {
          retrieveKakaoUserList.push({
            kakaoBotId: item.kakaoBotId,
            kakaoUserId: item.kakaoUserId,
            email: item.email,
          });
        });
        context.commit("setKakaoUserList", retrieveKakaoUserList);
      });
  },
  updateDevice(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "device/updateDevice",
          {
            deviceId: payload.deviceId,
            alias: payload.alias,
            deviceTypeId: "peon",
            devType: payload.devType,
            assignees: payload.assignees,
            isActive: payload.isActive,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          }
        )
        .then(response => {
          if (response.data.status === "0") {
            context.dispatch("retrievePeonList");

            resolve(response);
          } else {
            reject({
              status: response.data.status,
              message: response.data.message,
              error: response,
            });
          }
        })
        .catch(error => {
          reject({
            status: error.response.status,
            message: error.toString(),
            error: error,
          });
        });
    });
  },

};

function toDateString(date) {
  var year = date.getFullYear();
  var month = 1 + date.getMonth();
  month = month >= 10 ? month : "0" + month;
  var day = date.getDate();
  day = day >= 10 ? day : "0" + day;

  return year + "-" + month + "-" + day;
}
